import React from 'react';

function Blockchain3({fill = 'currentColor', secondaryfill, strokewidth = 1, width = '1em', height = '1em', ...props}) {
	secondaryfill = secondaryfill || fill;

	return (
		<svg height={height} width={width} {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
	<g fill={fill} strokeLinecap="butt" strokeLinejoin="miter">
		<polyline fill="none" points="2 6.5 9 10 16 6.5" stroke={fill} strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<polyline fill="none" points="16 6.5 23 10 30 6.5" stroke={fill} strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<polyline fill="none" points="9 18.5 16 22 23 18.5" stroke={secondaryfill} strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<line fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth={strokewidth} x1="9" x2="9" y1="10" y2="18.5"/>
		<line fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth={strokewidth} x1="23" x2="23" y1="10" y2="18.5"/>
		<line fill="none" stroke={secondaryfill} strokeMiterlimit="10" strokeWidth={strokewidth} x1="16" x2="16" y1="22" y2="30.5"/>
		<polygon fill="none" points="16 6.5 9 2.999 2 6.5 2 15 9 18.5 16 15 16 6.5" stroke={fill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<polygon fill="none" points="30 6.5 23 2.999 16 6.5 16 15 23 18.5 30 15 30 6.5" stroke={fill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<polygon fill="none" points="23 18.5 16 14.999 9 18.5 9 27 16 30.5 23 27 23 18.5" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
	</g>
</svg>
	);
};

export default Blockchain3;